// src/widget-config/content-hash.ts
function canonicalize(value) {
  if (value === void 0) {
    return "null";
  }
  if (value === null || typeof value !== "object") {
    return JSON.stringify(value);
  }
  if (Array.isArray(value)) {
    return `[${value.map((item) => canonicalize(item)).join(",")}]`;
  }
  const obj = value;
  const entries = Object.keys(obj).sort().filter((key) => obj[key] !== void 0).map((key) => `${JSON.stringify(key)}:${canonicalize(obj[key])}`);
  return `{${entries.join(",")}}`;
}
function fnv1aHex(input) {
  let hash = 2166136261;
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(16).padStart(8, "0");
}
function contentHash(value) {
  return fnv1aHex(canonicalize(value));
}

export { canonicalize, contentHash, fnv1aHex };
//# sourceMappingURL=chunk-LNHDZZEJ.js.map
//# sourceMappingURL=chunk-LNHDZZEJ.js.map